import classnamesBind from "classnames/bind";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import useReturnNotesSummary from "./hooks/useReturnNotesSummary";
import styles from "./ReturnNotesSummary.scss";

const classnames = classnamesBind.bind(styles);

type RuntimeConstantsShape = {
  getTranslation: (translationKey: string) => string;
};

const ReturnNotesSummary = () => {
  const { getTranslation } = useRuntimeConstants() as RuntimeConstantsShape;
  const returnNotesSummary = useReturnNotesSummary();

  if (!returnNotesSummary) {
    return null;
  }

  const { disclaimer, summary } = returnNotesSummary;

  return (
    <section
      className={styles.sectionContainer}
      aria-labelledby="returnNotesTitle"
    >
      <div
        className={styles.maxWidthContainer}
        data-testid="returnNotesSection"
      >
        <div
          className={classnames(styles.wrapper)}
          data-testid="return-notes-summary"
        >
          <h3 className={styles.title} id="returnNotesTitle">
            {getTranslation("pdp_ratings_reviews_return_reason_summary_title")}
          </h3>
          <p className={styles.summary}>{summary}</p>
          <div className={styles.disclaimerWrapper}>
            <span
              className={classnames(
                styles.disclaimerIcon,
                "product-ai-summary-icon",
              )}
            ></span>
            <p className={styles.disclaimer}>{disclaimer}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReturnNotesSummary;
